import { useApolloClient } from '@apollo/client';
import { useCallback, useEffect, useRef, useState } from 'react';
import { QUERY } from '../gql-operations';

export const getMessageReferenceId = message =>
    String(message?.referencedMessageId || message?.parentMessageId || '').trim();

export default function useOpenMessageReference(message, onOpenMessage) {
    const apolloClient = useApolloClient();
    const targetId = getMessageReferenceId(message);
    const currentTargetRef = useRef(targetId);
    currentTargetRef.current = targetId;
    const [opening, setOpening] = useState(false);
    useEffect(() => {
        currentTargetRef.current = targetId;
        return () => { currentTargetRef.current = null; };
    }, [targetId]);

    const openOriginalMessage = useCallback(async () => {
        if (opening || !targetId || typeof onOpenMessage !== 'function') return;
        setOpening(true);
        try {
            const result = await apolloClient.query({
                query: QUERY.GET_MESSAGE,
                variables: { data: { id: targetId } },
                fetchPolicy: 'cache-first'
            });
            const original = result?.data?.getMessage;
            if (original?.id === targetId && currentTargetRef.current === targetId) {
                onOpenMessage({ ...original, previewMode: 'MESSAGE', loadContext: false });
            }
        } catch (_error) {
            // Keep the current preview when the original is no longer accessible.
        } finally {
            if (currentTargetRef.current !== null) setOpening(false);
        }
    }, [apolloClient, onOpenMessage, opening, targetId]);

    return { openOriginalMessage, opening, targetId };
}
